import { DestroyRef, inject, Injectable, signal } from '@angular/core';

const PASSWORD_RESEND_COOLDOWN = 60;

@Injectable()
export class ResendCooldownService {
    private readonly destroyRef = inject(DestroyRef);

    private readonly _timeLeft = signal<number>(PASSWORD_RESEND_COOLDOWN);
    private readonly _isDisabled = signal<boolean>(false);

    readonly timeLeft = this._timeLeft.asReadonly();
    readonly isDisabled = this._isDisabled.asReadonly();

    private interval: ReturnType<typeof setInterval> | null = null;

    constructor() {
        this.destroyRef.onDestroy(() => this.clear());
    }

    start(): void {
        this.clear();
        this._timeLeft.set(PASSWORD_RESEND_COOLDOWN);
        this._isDisabled.set(true);
        this.interval = setInterval(() => {
            this._timeLeft.update((s) => s - 1);
            if (this._timeLeft() <= 0) {
                this.clear();
                this._isDisabled.set(false);
            }
        }, 1000);
    }

    disable(): void {
        this.clear();
        this._isDisabled.set(true);
    }

    enable(): void {
        this._isDisabled.set(false);
    }

    private clear(): void {
        if (this.interval !== null) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}
